export default __webpack_public_path__ + "static/media/technical-surveying.018145da.png";